import {
  BodyLinkV3,
  List,
  ListItem,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';

import RichText from '@/app/components/RichText';

import type { TCSectionData } from './types';

const TCSection = ({
  title,
  paragraphs,
  listItems,
  endParagraphs,
}: TCSectionData) => {
  const t = useTranslations();

  return (
    <>
      {title && (
        <TypographyV3 Element="h3" variant="h3">
          {t(title)}
        </TypographyV3>
      )}

      {paragraphs.map(({ id, paragraph, links }) => {
        const linkObj = links?.reduce((acc, link) => {
          const { localiseKey, href, skipLocalisedString, text } = link;
          return {
            ...acc,
            [localiseKey]: (
              <BodyLinkV3
                key={`${id}-link-${href}`}
                color="inherit"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {skipLocalisedString ? text : t(text)}
              </BodyLinkV3>
            ),
          };
        }, {});

        return (
          <Fragment key={id}>
            {!links && <TypographyV3>{t(paragraph)}</TypographyV3>}
            {linkObj && (
              <TypographyV3>
                <RichText messageKey={paragraph} tValues={linkObj} />
              </TypographyV3>
            )}
          </Fragment>
        );
      })}

      {listItems && (
        <List Element="ul">
          {listItems.map(({ id, text }) => (
            <ListItem key={id}>{t(text)}</ListItem>
          ))}
        </List>
      )}

      {endParagraphs?.map(({ id, paragraph }) => (
        <TypographyV3 key={id}>{t(paragraph)}</TypographyV3>
      ))}
    </>
  );
};

export default TCSection;
